import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  form: {
    marginBottom: '20px',
  },
  passwordField: {
    maxWidth: '358px',
    '& div': {
      maxHeight: '44px',
    },
    '& button': {
      padding: '9px 14px',
    },
    '& input': {
      padding: '11px 16px',
    },
  },
  buttons: {
    display: 'flex',
    marginTop: theme.spacing(1),
  },
  saveButton: {
    marginRight: theme.spacing(2),
    backgroundColor: '#00588f',
  },
}));
